
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locale/brands/detail",
      function () {
        return require("private-next-pages/locale/brands/detail.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locale/brands/detail"])
      });
    }
  